<template>
  <button
    v-if="clickable"
    class="btn border-0 p-0 d-flex align-items-center rounded"
    type="button"
    @click="onStatusChange"
  >
    <span
      class="status-caret badge text-uppercase"
      :class="`bg-opacity-${opacity} text-${textColor} bg-${bgColor} ${textSize} status-badge-${badgeSize}`"
    >
      {{ readableStatus }}
    </span>
    <span class="caret rotate--90 w-auto" :class="`text-${textColor}`"></span>
  </button>
  <span
    v-else
    class="badge text-uppercase"
    :class="`bg-opacity-${opacity} text-${textColor} bg-${bgColor} ${textSize} status-badge-${badgeSize}`"
  >
    {{ readableStatus }}
  </span>
</template>

<script setup lang="ts">
import { BadgeSize, BootstrapColorEnum } from '@/shared'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    status: string
    opacity?: number
    clickable?: boolean
    textColor?: string
    bgColor?: string
    textSize?: string
    badgeSize?: BadgeSize
  }>(),
  {
    opacity: 10,
    clickable: false,
    textColor: BootstrapColorEnum.Primary,
    bgColor: BootstrapColorEnum.Primary,
    textSize: 'fs-6',
    badgeSize: 'md',
  },
)

const emits = defineEmits<{
  (e: 'change'): void
}>()

const onStatusChange = () => {
  emits('change')
}

const readableStatus = computed<string>(() => props.status.replace('_', ' '))
</script>

<style lang="scss" scoped>
.status-caret.badge {
  top: 0 !important;
}

.status-caret {
  padding-right: 1.25rem;

  &::after {
    content: '';
    border-right: 1px solid;
    margin-left: 0.5rem;
    margin-right: 0.25rem;
    color: inherit;
  }

  & + .caret {
    margin-left: -0.75rem;
  }
}

// Introduce larger text for larger statuses when needed
.status-badge-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.status-badge-md {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.status-badge-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
</style>
